/* eslint-disable */

const parseDom = (str) => {
  const dom = document.createElement('div');
  dom.innerHTML = str;
  return dom.childNodes;
};

class BigoDanMu {
  constructor() {
    this.danMuBoxJQ = document.querySelector('#liveVideo');
    this.danMuWidth = document.querySelector('#liveVideo').clientWidth;
    this.danMuHeight = document.querySelector('#liveVideo').clientHeight;
    this.danMuMsg = [];
    this.setTimeoutAdjustId = null;
    this.allComingMsg = [];
    this.allTimeDelayMsg = [];
    this.danMuIntervalId = null;
    this.lastDrawDanMuTime = 0;
    this.payDanMuMsg = [];
    this.payTimeDelayMsg = [];
    this.payDanMuHtml =
      '<div class="pay_danmu_list"><div class="pay_words">=== : ===</div><p class="shadow_bg"></p></div>';
    this.payDanMuBox = document.querySelector('#bigo_dom_danmu_e');

    this.danMuTag = (function() {
      var danMuTag = document.getElementById('bigo_danmu_e');
      var room_video_e = document.querySelector('#liveVideo');
      danMuTag.width = room_video_e.clientWidth;
      // danMuTag.height = BigoLiveMsgPush.videoType === 1? ( document.body.clientHeight-250):danMuTag.width*9/16;
      danMuTag.height = document.body.clientHeight - 250;
      return danMuTag;
    })();

    this.canvas = null;
  }

  getCanvas() {
    if (this.canvas) return this.canvas;

    var canvas = document.getElementById('bigo_danmu_e');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    ctx.font = '30px sans_300';
    ctx.fillStyle = '#FFFFFF';
    ctx.textBaseline = 'top';
    ctx.shadowColor = 'rgba(46, 46, 46, 1)';
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = 1;
    return ctx;
  }

  adjustDanMuWidthHeight() {
    var that = this;
    that.danMuTag.width = that.danMuWidth = that.danMuBoxJQ.clientWidth;
    that.danMuTag.height = that.danMuHeight = that.danMuBoxJQ.clientHeight;
    // var ctx = this.getCanvas();
    // ctx.font = '30px sans_300';
    // ctx.fillStyle = '#FFFFFF';
    // ctx.textBaseline = 'top';
    // ctx.shadowColor = 'rgba(46, 46, 46, 1)';
    // ctx.shadowOffsetX = 0;
    // ctx.shadowOffsetY = 0;
    // ctx.shadowBlur = 1;
  }

  setDanMuY() {
    var danMuMsgArray = this.danMuMsg;
    var maxY = this.danMuHeight - 80;
    var maxX = this.danMuWidth;
    var len = danMuMsgArray.length;
    var allComingMsg = this.allComingMsg;
    allComingMsg = [];
    for (var i = 0; i < len; i++) {
      if (danMuMsgArray[i].coming) {
        allComingMsg.push(danMuMsgArray[i].y);
      }
    } //存储还没有走完的消息记录
    allComingMsg.sort();
    for (var j = 0, len2 = Math.floor(maxY / 30); j < len2; j++) {
      if (allComingMsg.indexOf(j * 30 + 10) === -1) {
        return j * 30 + 10;
      }
    } //返回可以利用的轨道Y值
    return 0;
  }

  readyArguments(msg) {
    var x = this.danMuWidth;
    var ctx = this.getCanvas();
    // var msglen = msg.length*20;//每个字符，占据的最大宽度
    var msglen = ctx.measureText(msg).width + 35;
    msglen = msglen < 150 ? 150 : msglen;
    // var y=10;//最顶上的值
    var y = this.setDanMuY(); //轨道间隙中的内容，表示触发爆屏
    if (y === 0) {
      this.allTimeDelayMsg.push({
        msg: msg,
        x: x,
        y: y,
        msglen: msglen,
        coming: true,
        date: +new Date()
      });
      if (this.allTimeDelayMsg.length > 200) {
        this.allTimeDelayMsg.shift();
      }
      return;
    }
    this.danMuMsg.push({ msg: msg, x: x, y: y, msglen: msglen, coming: true });

  }

  drawDanMu() {
    var that = this;
    var ctx = this.getCanvas();
    if (!ctx) return;
    ctx.clearRect(0, 0, that.danMuWidth, that.danMuHeight);
    var allMsgArray = that.danMuMsg;
    var text = '';
    var a = null;
    var dateNow = +new Date();
    var dateLast = that.lastDrawDanMuTime;
    var lenK =
      (dateNow - dateLast) / 50 < 2 ? 1 : Math.floor((dateNow - dateLast) / 50);
    for (var i = 0; i < allMsgArray.length; i++) {
      text = allMsgArray[i].msg;
      ctx.fillText(text, allMsgArray[i].x, allMsgArray[i].y);
      allMsgArray[i].x -=
        Math.floor(Math.pow(allMsgArray[i].msglen, 1 / 4)) * lenK;

      if (allMsgArray[i].coming) {
        if (allMsgArray[i].x + allMsgArray[i].msglen < that.danMuWidth) {
          allMsgArray[i].coming = false;
          if (that.allTimeDelayMsg.length) {
            a = that.allTimeDelayMsg.shift();
            a.y = allMsgArray[i].y;
            // a.x += (dateNow-a.date)/50<4?0:(dateNow-a.date)/50*Math.floor(Math.pow(a.msglen, 1/4));
            allMsgArray.push(a);
          }
        }
      }
      if (allMsgArray[i].x < -allMsgArray[i].msglen) {
        allMsgArray.splice(i, 1);
        i--;
      }
    }
    that.lastDrawDanMuTime = dateNow;
  }

  clearEndAndCheckAddNew(clearval) {
    var payDanMuMsg = this.payDanMuMsg;
    var payTimeDelayMsg = this.payTimeDelayMsg;
    var index = payDanMuMsg.indexOf(clearval);
    var payTimeDelay = {};
    payDanMuMsg.splice(index, 1); //删除过期弹幕.
    if (payTimeDelayMsg.length) {
      payTimeDelay = payTimeDelayMsg.shift();
      this.appendPayDanMu(payTimeDelay.user, payTimeDelay.msg);
    }
  }

  appendPayDanMu(user, msg) {
    var msgMoveTrackNum = Math.floor((this.danMuHeight - 90) / 45);
    var payDanMuMsg = this.payDanMuMsg;
    var gotTrack = 0;
    var str = '';
    var jqObj = null;
    var ctx = this.getCanvas();
    var msglen = 0;
    var that = this;
    payDanMuMsg.sort();
    for (var i = 0, len = payDanMuMsg.length; i < msgMoveTrackNum; i++) {
      if (payDanMuMsg.indexOf(i + 1) === -1) {
        gotTrack = i + 1;
        break;
      }
    }
    if (len === 0) {
      gotTrack = 1;
    }
    if (gotTrack === 0) {
      this.payTimeDelayMsg.push({ user: user, msg: msg });
      return;
    }
    payDanMuMsg.push(gotTrack);
    str = this.payDanMuHtml.replace('===', user).replace('===', msg);
    jqObj = parseDom(str)[0] || {};
    msglen = ctx.measureText(user + msg).width * 0.8 + 50;
    this.payDanMuBox.appendChild(jqObj);
    setTimeout(
      (function(jqObj) {
        return function() {
          jqObj.style.left = -(msglen + 70) + 'px';
          jqObj.style.width = msglen + 60 + 'px';
          jqObj.style.top = 10 + (gotTrack - 1) * 45 + 'px';
        };
      })(jqObj),
      20
    );
    setTimeout(
      (function(jqObj, gotTrack, that) {
        return function() {
          // jqObj.remove();
          that.payDanMuBox.removeChild(jqObj);
          that.clearEndAndCheckAddNew(gotTrack);
        };
      })(jqObj, gotTrack, that),
      12500
    );
  }
}

export default BigoDanMu;
